import styled from '@emotion/styled';
import { spacing } from '@mui/system';

export default styled.div(spacing);
